module.exports = __webpack_public_path__ + "static/img/noindents.65c7da4.svg";